var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.27777,
    cy: 9.69061,
    r: 8.48871,
    fill: "white",
    stroke: "#335443"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66153 11.101V10.49C8.66153 10.1087 8.73086 9.75767 8.86953 9.437C9.0082 9.10767 9.24653 8.761 9.58453 8.397C9.8272 8.137 9.9962 7.916 10.0915 7.734C10.1869 7.54333 10.2345 7.34833 10.2345 7.149C10.2345 6.90633 10.1435 6.71567 9.96153 6.577C9.7882 6.43833 9.53686 6.369 9.20753 6.369C8.40153 6.369 7.6432 6.65933 6.93253 7.24L6.29553 5.758C6.67686 5.42867 7.14053 5.16867 7.68653 4.978C8.23253 4.78733 8.7872 4.692 9.35053 4.692C9.92253 4.692 10.4252 4.78733 10.8585 4.978C11.2919 5.16 11.6255 5.42 11.8595 5.758C12.1022 6.08733 12.2235 6.473 12.2235 6.915C12.2235 7.31367 12.1325 7.682 11.9505 8.02C11.7772 8.358 11.4652 8.71333 11.0145 9.086C10.6072 9.424 10.3255 9.71867 10.1695 9.97C10.0222 10.2213 9.9312 10.464 9.89653 10.698L9.83153 11.101H8.66153ZM8.19353 14V11.92H10.2995V14H8.19353Z",
    fill: "#335443"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.2b9956cebfa5317b4717b7d459ca2d79.svg";
export { ForwardRef as ReactComponent };